export default {
    imgPath: typeof imgPath === 'undefined' ? '/o/quebecor-theme/images/' : imgPath,
    styles: {
        baseFontSize: 15
    },
    mq : { // Important, keep it sync with config.scss
        lg: 1260,
        md:  992,
        mm:  920,
        smmin:  768,
        sm:  769,
        xs:  520,
        xxs: 380
    }
};



// WEBPACK FOOTER //
// ./src/main/js/utils/conf.js